import { createSelector } from '@reduxjs/toolkit'
import { merklebaseAPI } from 'store/api/merklebaseAPI'

// Base selectors - select RTK Query cache results (no-arg or fixed-arg queries)
const selectBalancesResult = merklebaseAPI.endpoints.getBalances.select()
const selectAccountsBalancesResult = merklebaseAPI.endpoints.getAccountsBalances.select()
const selectMarginBalancesResult = merklebaseAPI.endpoints.getMarginBalances.select()
const selectBalancesByPortfolioByCurrencyResult =
  merklebaseAPI.endpoints.getBalancesByPortfolioByCurrency.select()
const selectDailyPositionsResult = merklebaseAPI.endpoints.getDailyPositions.select()

// Raw data selectors
export const selectBalancesRaw = createSelector(
  [selectBalancesResult],
  (result) => result?.data ?? []
)

export const selectAccountsBalancesRaw = createSelector(
  [selectAccountsBalancesResult],
  (result) => result?.data ?? []
)

export const selectMarginBalancesRaw = createSelector(
  [selectMarginBalancesResult],
  (result) => result?.data ?? []
)

export const selectBalancesByPortfolioByCurrencyData = createSelector(
  [selectBalancesByPortfolioByCurrencyResult],
  (result) => result?.data ?? {}
)

export const selectDailyPositionsData = createSelector(
  [selectDailyPositionsResult],
  (result) => result?.data ?? {}
)

// Loading selectors
export const selectBalancesLoading = createSelector(
  [selectBalancesResult],
  (result) => (result?.isLoading || result?.isFetching || false)
)

export const selectAccountsBalancesLoading = createSelector(
  [selectAccountsBalancesResult],
  (result) => (result?.isLoading || result?.isFetching || false)
)

export const selectAccountsBalancesFetching = createSelector(
  [selectAccountsBalancesResult],
  (result) => result?.isFetching ?? false
)

export const selectMarginBalancesLoading = createSelector(
  [selectMarginBalancesResult],
  (result) => (result?.isLoading || result?.isFetching || false)
)

export const selectBalancesByPortfolioByCurrencyLoading = createSelector(
  [selectBalancesByPortfolioByCurrencyResult],
  (result) => (result?.isLoading || result?.isFetching || false)
)

export const selectDailyPositionsLoading = createSelector(
  [selectDailyPositionsResult],
  (result) => (result?.isLoading || result?.isFetching || false)
)
